import {createActionGroup, emptyProps, props} from '@ngrx/store';
import {AccountModel} from "../models/account.model";
import {FirebaseChannelResponse} from "../../../persistence-layer/models/firebase-channel-response.model";
import {TaskModel} from "../../../tasks/models/task.model";

export const AccountsChannelActions = createActionGroup({
  source: '[Account/Channel]',
  events: {
    subscribe: emptyProps(),
    unsubscribe: emptyProps(),
    unsubscribeSuccess: emptyProps(),
    notificationReceived: props<{ notification: AccountModel }>(),
  },
});

export const AccountsAPiActions = createActionGroup({
  source: '[Account/API]',
  events: {

    //Get accounts
    getAccounts: props<{ params?: any }>(),
    getAccountsSuccess: props<{ accounts: AccountModel[], cursor?: string }>(),
    getAccountsFailure: props<{ error: any }>(),

    //Get account
    getAccount: props<{ id: string }>(),
    getAccountSuccess: props<{ account: AccountModel }>(),
    getAccountFailure: props<{ error: any }>(),

    //Create account
    createAccount: props<{account: AccountModel }>(),
    createAccountSuccess: props<{ account: AccountModel }>(),
    createAccountFailure: props<{ error: any }>(),

    //Update account
    updateAccount: props<{ id: string, account: AccountModel }>(),
    updateAccountSuccess: props<{ account: AccountModel }>(),
    updateAccountFailure: props<{ error: any }>(),

    //Delete account
    deleteAccount: props<{ id: string, shouldMask?: boolean }>(),
    deleteAccountSuccess: props<{ account: AccountModel }>(),
    deleteAccountFailure: props<{ error: any }>()

  },
});


export const AccountsActions = createActionGroup({
  source: '[Account]',
  events: {
    setAccounts: props<{ accounts: AccountModel[] }>(),
    removeAccounts: props<{ ids: string[] }>(),
    removeAll: emptyProps(),
    clearStore: emptyProps()
  }
});


